var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
import { ChildProperty, Property, Event } from '@syncfusion/ej2-base';
/**
 * Represents TransformSettings in the Inline Toolbar of block editor component.
 */
export class TransformSettings extends ChildProperty {
}
__decorate([
    Property([])
], TransformSettings.prototype, "items", void 0);
__decorate([
    Event()
], TransformSettings.prototype, "itemSelect", void 0);
__decorate([
    Property('auto')
], TransformSettings.prototype, "popupWidth", void 0);
__decorate([
    Property('auto')
], TransformSettings.prototype, "popupHeight", void 0);
